// extracted by mini-css-extract-plugin
export default {"subBox":"subProgress_subBox__bFIxK"};